import { Component, Input, EventEmitter, Output } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { CustomerEnum } from '../../enums/customer.enum';
import { RequestListItem } from '../../models/request/request-list-item';
import { RequestStatus } from '../../enums';

@Component({
	selector: 'mobile-requests-card',
	templateUrl: './mobile-requests-card.component.html',
	styleUrls: [
		'./mobile-requests-card.component.scss'
	]
})
export class MobileRequestsCardComponent {

	@Input() request: RequestListItem = null;

	@Output() click = new EventEmitter<any>();

}
